import React, { useEffect, useState } from "react";
import axiosOrganizationInstance from "./AxiosOrganizationInstance";
import { getAuthHeaders, getStoredOrganizationId } from "./organizationStorage";
import { OrdersTable, OrdersTabs } from "./OrdersTable";
import "./css/today.css";

const Today = () => {
  const [orders, setOrders] = useState([]);
  const [pickupOrders, setPickupOrders] = useState([]);
  const [activeTab, setActiveTab] = useState("restaurantOrders");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [todayDate, setTodayDate] = useState(""); // State to store today's date
  const organizationId = getStoredOrganizationId();

  // Get today's date in the required format (YYYY-MM-DD)
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);
        setError(null);

        const date = getTodayDate(); 
        setTodayDate(date); 
        if (!organizationId) {
          throw new Error("Organization not found. Please sign in again.");
        }

        const response = await axiosOrganizationInstance.get(
          `/organization/${organizationId}/orders`,
          {
            headers: getAuthHeaders(),
            params: { selectedDate: date },
          }
        );

        if (response.data.status === "success") {
          setOrders(response.data.data.orders || []);
          setPickupOrders(response.data.data.pickup_orders || []);
        } else {
          throw new Error("Failed to fetch orders and pickup orders");
        }
      } catch (err) {
        console.error(err);
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [organizationId]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  return (
    <div className="today-container">
      <div className="today-content">
        <OrdersTabs activeTab={activeTab} onChange={setActiveTab}>
          <span className="org-orders-date">({todayDate})</span>
        </OrdersTabs>

        {activeTab === "restaurantOrders" && (
          <div className="today-table-container">
            {orders.length === 0 ? (
              <p className="nodata">No restaurant orders available for today.</p>
            ) : (
              <OrdersTable rows={orders} idKey="orderId" />
            )}
          </div>
        )}

        {activeTab === "pickupOrders" && (
          <div className="today-table-container">
            {pickupOrders.length === 0 ? (
              <p className="nodata">No pickup orders available for today.</p>
            ) : (
              <OrdersTable rows={pickupOrders} idKey="pickupId" />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Today;
